namespace TabAurous.Administration {
    export namespace QualityInspectionTemplateDetailsService {
        export const baseUrl = 'Administration/QualityInspectionTemplateDetails';

        export declare function Create(request: Serenity.SaveRequest<QualityInspectionTemplateDetailsRow>, onSuccess?: (response: Serenity.SaveResponse) => void, opt?: Q.ServiceOptions<any>): JQueryXHR;
        export declare function Update(request: Serenity.SaveRequest<QualityInspectionTemplateDetailsRow>, onSuccess?: (response: Serenity.SaveResponse) => void, opt?: Q.ServiceOptions<any>): JQueryXHR;
        export declare function Delete(request: Serenity.DeleteRequest, onSuccess?: (response: Serenity.DeleteResponse) => void, opt?: Q.ServiceOptions<any>): JQueryXHR;
        export declare function Retrieve(request: Serenity.RetrieveRequest, onSuccess?: (response: Serenity.RetrieveResponse<QualityInspectionTemplateDetailsRow>) => void, opt?: Q.ServiceOptions<any>): JQueryXHR;
        export declare function List(request: Serenity.ListRequest, onSuccess?: (response: Serenity.ListResponse<QualityInspectionTemplateDetailsRow>) => void, opt?: Q.ServiceOptions<any>): JQueryXHR;

        export declare const enum Methods {
            Create = "Administration/QualityInspectionTemplateDetails/Create",
            Update = "Administration/QualityInspectionTemplateDetails/Update",
            Delete = "Administration/QualityInspectionTemplateDetails/Delete",
            Retrieve = "Administration/QualityInspectionTemplateDetails/Retrieve",
            List = "Administration/QualityInspectionTemplateDetails/List"
        }

        [
            'Create', 
            'Update', 
            'Delete', 
            'Retrieve', 
            'List'
        ].forEach(x => {
            (<any>QualityInspectionTemplateDetailsService)[x] = function (r, s, o) {
                return Q.serviceRequest(baseUrl + '/' + x, r, s, o);
            };
        });
    }
}
